/**
 * Header State Reducer
 *
 * Contains the main state reducer and all action handlers
 * for the header state management system.
 */

import { HEADER_STATE_ACTIONS, initialHeaderState } from './headerStateConfig'

// State reducer for complex state updates
export const headerStateReducer = (state, action) => {
  switch (action.type) {
    case HEADER_STATE_ACTIONS.TOGGLE_MENU: {
      const { menuKey } = action.payload
      return {
        ...state,
        menu: {
          ...state.menu,
          [menuKey]: !state.menu[menuKey]
        }
      }
    }

    case HEADER_STATE_ACTIONS.SET_MENU_VISIBILITY: {
      const { menuKey, isVisible } = action.payload
      return {
        ...state,
        menu: {
          ...state.menu,
          [menuKey]: isVisible
        }
      }
    }

    case HEADER_STATE_ACTIONS.SET_CURRENT_CLICK: {
      const { clickType } = action.payload
      return {
        ...state,
        menu: {
          ...state.menu,
          currentHeaderClick: clickType
        }
      }
    }

    case HEADER_STATE_ACTIONS.SET_ACTIVE_CATEGORY: {
      const { categoryName } = action.payload
      const newCategory =
        state.menu.activeMainCategory === categoryName ? null : categoryName
      return {
        ...state,
        menu: {
          ...state.menu,
          activeMainCategory: newCategory
        }
      }
    }

    case HEADER_STATE_ACTIONS.CLOSE_ALL_MENUS: {
      return {
        ...state,
        menu: {
          ...state.menu,
          isAccountMenuVisible: false,
          isViewFilesMenuVisible: false,
          isMobileTopLevelMenuVisible: false,
          isCreateKinCategoryMenuVisible: false,
          currentHeaderClick: 'closeAll'
        }
      }
    }

    case HEADER_STATE_ACTIONS.SET_SEARCH_TERM: {
      const { searchTerm } = action.payload
      return {
        ...state,
        search: {
          ...state.search,
          searchTerm
        }
      }
    }

    case HEADER_STATE_ACTIONS.CLEAR_SEARCH: {
      return {
        ...state,
        search: {
          ...state.search,
          searchTerm: ''
        }
      }
    }

    case HEADER_STATE_ACTIONS.SET_TIMEOUT_ID: {
      const { timeoutKey, timeoutId } = action.payload
      return {
        ...state,
        timeouts: {
          ...state.timeouts,
          [timeoutKey]: timeoutId
        }
      }
    }

    case HEADER_STATE_ACTIONS.CLEAR_TIMEOUT_ID: {
      const { timeoutKey } = action.payload
      const timeoutId = state.timeouts[timeoutKey]
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      return {
        ...state,
        timeouts: {
          ...state.timeouts,
          [timeoutKey]: null
        }
      }
    }

    case HEADER_STATE_ACTIONS.CLEAR_ALL_TIMEOUTS: {
      // Clear all active timeouts
      Object.values(state.timeouts).forEach(timeoutId => {
        if (timeoutId) clearTimeout(timeoutId)
      })
      return {
        ...state,
        timeouts: {
          viewFilesTimeoutId: null,
          kinCategoriesTimeoutId: null,
          uploadTimeoutId: null,
          accountTimeoutId: null,
          buildYourOwnTimeoutId: null
        }
      }
    }

    case HEADER_STATE_ACTIONS.SET_NOTIFICATION: {
      const { showNotification, welcomeMessage } = action.payload
      return {
        ...state,
        notifications: {
          ...state.notifications,
          showNotification:
            showNotification !== undefined
              ? showNotification
              : state.notifications.showNotification,
          welcomeMessage:
            welcomeMessage !== undefined
              ? welcomeMessage
              : state.notifications.welcomeMessage
        }
      }
    }

    case HEADER_STATE_ACTIONS.CLEAR_NOTIFICATION: {
      return {
        ...state,
        notifications: {
          ...state.notifications,
          showNotification: false
        }
      }
    }

    case HEADER_STATE_ACTIONS.BATCH_UPDATE: {
      const { updates } = action.payload
      return {
        ...state,
        ...updates
      }
    }

    case HEADER_STATE_ACTIONS.RESET_STATE: {
      return initialHeaderState
    }

    case HEADER_STATE_ACTIONS.RESTORE_STATE: {
      const { restoredState } = action.payload
      return { ...initialHeaderState, ...restoredState }
    }

    default:
      console.warn('Unknown header state action:', action.type)
      return state
  }
}
